import { TableCellVerticalAlignment as Base, CELL_VERTICAL_ALIGNMENT_OPTIONS } from "@corca/tiptap";

import type { CellVerticalAlignment } from "@corca/tiptap";
import type { Editor } from "@tiptap/react";

export { CELL_VERTICAL_ALIGNMENT_OPTIONS };
export type { CellVerticalAlignment };

export function getCellVerticalAlignment(editor: Editor): CellVerticalAlignment {
  if (editor.isActive({ verticalAlignment: "center" })) {
    return "center";
  }

  if (editor.isActive({ verticalAlignment: "bottom" })) {
    return "bottom";
  }

  return "top";
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    tableCellVerticalAlignment: {
      setCellVerticalAlignment: (alignment: CellVerticalAlignment) => ReturnType;
    };
  }
}

export const TableCellVerticalAlignment = Base.extend({
  addCommands() {
    return {
      setCellVerticalAlignment:
        (alignment: CellVerticalAlignment) =>
        ({ commands }) => {
          return this.options.types
            .map((type) => commands.updateAttributes(type, { verticalAlignment: alignment }))
            .every((response) => response);
        },
    };
  },
});
